import apiFetch from '../apiFetch'

export default function (dossierId, token, entityFromParent) {
  return apiFetch({ endPoint: `Dossier/${dossierId}/DeleteEntity/${entityFromParent}`, method: 'PUT', token: token })
}
